import type { ActivityState, ReduxAction } from '../types/common';

/** UTC day string, matching the server's streak day boundary. */
const todayString = () => new Date().toISOString().slice(0, 10);

/** Seconds of active time needed to earn a day's streak (mirrors the server). */
export const STREAK_GOAL_SECONDS = 20 * 60;

const initialState: ActivityState = {
  date: todayString(),
  activeSeconds: 0,
  goalSeconds: STREAK_GOAL_SECONDS,
  earnedToday: false,
};

const activityReducer = (
  state: ActivityState = initialState,
  action: ReduxAction<Partial<ActivityState>>
): ActivityState => {
  switch (action.type) {
    case 'SET_ACTIVITY':
      return { ...state, ...(action.payload as Partial<ActivityState>) };
    case 'RESET_ACTIVITY':
      return { ...initialState, date: todayString() };
    default:
      return state;
  }
};

/** Merge a partial activity update into the slice (dispatched by the tracker). */
export const setActivity = (payload: Partial<ActivityState>): ReduxAction<Partial<ActivityState>> => ({
  type: 'SET_ACTIVITY',
  payload,
});

export default activityReducer;
